import { useQuery } from '@tanstack/react-query'
import { aiStudioService } from '../../../service/aiStudio'

export const useAvatarFilters = () => {
  return useQuery({
    queryKey: ['ai-studio', 'avatar-filters'],
    queryFn: aiStudioService.getAvatarFilters,
    staleTime: 10 * 60 * 1000, // 10분 (필터 옵션은 자주 변경되지 않음)
  })
}

export const useFilteredAvatars = (filters: {
  gender: string[]
  ethnicity: string[]
}) => {
  return useQuery({
    queryKey: ['ai-studio', 'all-avatars'], // 필터와 무관하게 전체 아바타 조회
    queryFn: () => aiStudioService.getFilteredAvatars(),
    staleTime: 10 * 60 * 1000, // 10분 (전체 데이터는 더 오래 캐싱)
    enabled: true,
  })
}

// 기존 훅은 deprecated로 유지 (하위 호환성)
export const useAvailableAvatars = () => {
  return useFilteredAvatars({ gender: [], ethnicity: [] })
}
